import React from 'react';
import { graphql, useStaticQuery } from 'gatsby';
import { render } from 'datocms-structured-text-to-plain-text';
import styled from 'styled-components';
import { minBreakpointQuery, sectionMargins } from '../styles';
import { Container } from './ui';
import { buildUrl, hasStructuredText } from '../utils';
import BlogDetailIntroduction from './BlogDetailIntroduction';
import BlogTableOfContents from './BlogTableOfContents';
import ModularBlocks from './ModularBlocks';
import SocialShare from './SocialShare';
import BlogAuthor from './BlogAuthor';
import PardotForm from './PardotForm';
import FeaturedResource from './FeaturedResource';

const StyledBlogDetail = styled.div`
  position: relative;
`;

const StyledInner = styled.div`
  display: grid;

  ${minBreakpointQuery.xlarge`
    gap: 40px;
    grid-template-columns: 75fr 25fr;
  `}

  ${minBreakpointQuery.xxlarge`
    gap: 60px;
  `}
`;

const StyledSocialShare = styled(SocialShare)`
  ${minBreakpointQuery.xxxlarge`
    flex-direction: column;
    left: 30px;
    position: absolute;
    top: 0;
    ${sectionMargins('20px', '40px')};
  `}
`;

const StyledForm = styled(PardotForm)`
  ${minBreakpointQuery.xlarge`
    position: sticky;
    top: 40px;
    ${sectionMargins('20px', '40px')};
  `}
`;

const BlogDetail = ({
  blogPost,
  resource,
  introduction,
  anchorLinks,
  items,
  summary,
  summaryNew,
  author,
  title,
}) => {
  const {
    datoCmsBlogSitewide: { pardotFormUrl, pardotFormHeight },
  } = useStaticQuery(graphql`
    query BlogDetailQuery {
      datoCmsBlogSitewide {
        pardotFormUrl
        pardotFormHeight
      }
    }
  `);

  return (
    <StyledBlogDetail>
      <Container>
        <StyledInner>
          <div>
            <BlogDetailIntroduction introduction={introduction} />
            <BlogTableOfContents anchorLinks={anchorLinks} />
            <ModularBlocks
              items={items}
              resource={resource}
              isBlogDetail={true}
            />
            <StyledSocialShare
              text="Share"
              shareData={{
                title: title,
                text: hasStructuredText(summaryNew)
                  ? render(summaryNew)
                  : summary,
                url:
                  process.env.GATSBY_SITE_URL +
                  buildUrl(blogPost.slug, blogPost),
              }}
            />
            <BlogAuthor {...author} />
          </div>
          <StyledForm url={pardotFormUrl} height={pardotFormHeight} />
        </StyledInner>
      </Container>
      <FeaturedResource
        heading="Featured resource"
        resource={resource}
        isBlogDetail={true}
      />
    </StyledBlogDetail>
  );
};

export default BlogDetail;
